import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from '../recipient-addresses-dialog.module.scss';
import { CUIText } from '@dotcom/crown-ui';

export const OrderQuantity = ({ quantity }: { quantity: number }) => {
  const { t } = useTranslation();
  return (
    <div className={styles.orderQuantity}>
      <CUIText as="span" className={styles['text']} color="textSecondary" data-testid="typography">
        {t('recipientAddresses.orderQuantity')}
      </CUIText>

      <CUIText as="span" color="textSecondary" data-testid="typography">
        {quantity}
      </CUIText>
    </div>
  );
};
